import { map } from 'rxjs/operators';
// Constants / Utils
import { convertNestedStringToBoolean } from 'NewAngular/utils/state-utils';
import { getListPageRedirectUrl } from 'AccountsApp/ts/utils/utils';
import { ANALYSIS_PLAN_LIST_STATE_KEYS } from 'HypotheticalsApp/apps/analysis-plan-list-app/state/constants';
import { DEFAULT_ERROR_MSG } from 'HypotheticalsApp/apps/hypotheticals-app/constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
export class SavedAnalysisPlanService {
    constructor(accountsService, ajaxService, urlsService) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    async getSavedAnalysisListPageRedirectUrl(overrides) {
        return getListPageRedirectUrl(this.accountsService, this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_LIST_PAGE, 'saved_analysis_plan_list_page', ANALYSIS_PLAN_LIST_STATE_KEYS, overrides);
    }
    createItem(analysisPlanParams, itemName, targetFolder) {
        const postParams = { state: analysisPlanParams, name: itemName };
        if (targetFolder) {
            postParams.targetFolder = targetFolder;
        }
        const postUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_LIST);
        return this.ajaxService.postJsonDataObserveBody(postUrl, postParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    deleteItem(analysisPlanId) {
        const urlParams = { analysisPlanId };
        const deleteUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    getErrorMessage(error) {
        let errorMessage;
        switch (error.status) {
            case 404:
                errorMessage = 'Scenario not found, please try again.';
                break;
            case 403:
                errorMessage = error.error?.error_message ?? DEFAULT_ERROR_MSG;
                break;
            case 409:
                errorMessage = 'Cannot save with duplicate name, please try again.';
                break;
            default:
                errorMessage = DEFAULT_ERROR_MSG;
                break;
        }
        return errorMessage;
    }
    getItem(analysisPlanId) {
        const urlParams = { analysisPlanId };
        const getUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.getDataObserveBody(getUrl).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    getItems(getParams) {
        const getUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_LIST);
        return this.ajaxService.getDataObserveBody(getUrl, getParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    getFolderableItems(params) {
        const getUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_COLLECTION);
        return this.ajaxService.getDataObserveBody(getUrl, params);
    }
    updateItem(analysisPlanId, putParams) {
        const urlParams = { analysisPlanId };
        const putUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.putJsonDataObserveBody(putUrl, putParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
}
SavedAnalysisPlanService.ɵfac = function SavedAnalysisPlanService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedAnalysisPlanService)(i0.ɵɵinject(i1.AccountsService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
SavedAnalysisPlanService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedAnalysisPlanService, factory: SavedAnalysisPlanService.ɵfac, providedIn: 'root' });
